import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=66c39956"
import script from "./ProductFilter.vue?vue&type=script&lang=ts"
export * from "./ProductFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports